
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","xmlns":"http://www.w3.org/2000/svg","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.25 3.75h7.5v7.5h-7.5zM8.75 6.75h2.6l2.4 2.4v2.1h-5z","stroke":"currentColor","stroke-width":"1.4","stroke-linejoin":"round"}}),_c('circle',{attrs:{"cx":"5","cy":"12.75","r":"1.5","stroke":"currentColor","stroke-width":"1.4"}}),_c('circle',{attrs:{"cx":"11.5","cy":"12.75","r":"1.5","stroke":"currentColor","stroke-width":"1.4"}})])
          )
        }
      }
    